import type { TourStep } from '@/lib/tour/steps';

/**
 * <b>바뀐 것 하나만</b> 알리는 짧은 안내 (사용자 지시 2026-09-18).
 *
 * <h2>왜 전체 안내({@link TOUR_STEPS})에 걸음을 더하지 않았나</h2>
 * 그쪽은 {@code TOUR_VERSION} 을 올리면 다시 뜨는데, 그러면 <b>열한 걸음이 통째로</b> 다시 뜬다.
 * 이미 서비스를 쓰고 있는 사람에게 「메뉴 하나가 옮겨졌다」를 말하려고 처음부터 다시 보게 하는 것은
 * 안내가 아니라 방해다. 그래서 자기 이름({@link WHATS_NEW_TOUR_KEY})과 자기 판번호를 갖는다.
 *
 * <h2>새로 들어온 사람에게는 뜨지 않는다</h2>
 * 「바뀌었습니다」 는 <b>예전을 아는 사람</b>에게만 뜻이 있는 말이다. 전체 안내를 아직 안 본 계정
 * (= 처음 들어온 사람)에게는 이 안내를 띄우지 않고 조용히 본 것으로 적는다({@code AppLayout}).
 *
 * <h2>안 보이는 걸음은 스스로 빠진다</h2>
 * 위젯을 꺼 둔 사람에게는 {@code widget-news} 가 화면에 없어 둘째 걸음이 조용히 빠지고
 * ({@link TourOverlay} 의 걸러내기), 셋째 걸음 — 위젯 관리에서 켜라 — 만 남는다. 그 사람에게
 * 필요한 말이 정확히 그것이다.
 */

/** 서버에 진행 기록을 남길 때 쓰는 이름. 소문자·숫자·하이픈만 쓴다(서버가 같은 모양을 검증한다). */
export const WHATS_NEW_TOUR_KEY = 'whatsnew-news-entry';

/**
 * 이 안내만의 판번호. 전체 안내의 {@code TOUR_VERSION} 과 <b>따로</b> 움직인다 —
 * 저쪽을 올렸다고 이 「바뀐 것」 안내가 다시 뜨면 안 된다(그때는 이미 바뀐 것이 아니다).
 *
 * 1 — 뉴스·건설동향·식당안내가 사이드바에서 내려가고 홈 위젯이 입구가 됐다(2026-09-18).
 */
export const WHATS_NEW_VERSION = 1;

export const WHATS_NEW_STEPS: TourStep[] = [
  {
    key: 'whatsnew-intro',
    target: null,
    title: '왼쪽 메뉴가 조금 정리됐습니다',
    body:
      '<b>뉴스</b>와 <b>건설동향</b>이 왼쪽 메뉴에서 빠졌습니다. 없어진 것이 아니라 ' +
      '첫 화면(홈)의 위젯으로 들어가는 방식으로 바뀌었습니다. 어디를 누르면 되는지 짚어 드릴게요.',
  },
  {
    key: 'whatsnew-widget',
    target: 'widget-news',
    subTargets: ['widget-news-more'],
    title: '홈의 「뉴스·건설동향」 위젯입니다',
    body:
      '위젯 제목 옆의 <b>뉴스 / 건설동향</b> 토글로 둘을 오갑니다. 목록을 다 보려면 오른쪽 위의 ' +
      '반짝이는 <b>전체보기 ›</b> 를 누르세요 — 예전 메뉴로 들어가던 그 화면이 그대로 열립니다.',
  },
  {
    key: 'whatsnew-widget-manager',
    target: 'sidebar-widgets',
    title: '홈에 그 위젯이 안 보이면',
    body:
      '왼쪽 아래 <b>위젯 관리</b>에서 「뉴스·건설동향」을 켜면 첫 화면에 나타납니다. ' +
      '위젯 설정은 계정에 저장되니 다른 기기에서도 그대로 따라옵니다.',
    placement: 'right',
  },
];
